<template>
  <v-container fluid class="pa-0">
    <v-card class="elevation-0">
      <!-- Background Image -->
      <div class="footer-bg">
        <v-container>
          <div class="mt-10 mx-lg-8 pt-lg-10">
            <v-row>
              <!-- Left column -->
              <v-col cols="12" sm="3" class="mx-1">
                <div class="pa-4 white--text">
                  <div class="d-flex align-center fade-section">
                    <img
                      src="@/assets/sactin-logo.jpg"
                      alt="Image description"
                      style="width: 120px; border-radius: 9px"
                    />
                  </div>
                  <p class="mt-4 text-justify white--text fade-section">
                    We promise that the projects that are designed and developed by us
                    will be the best with industry standards and will be built using
                    high-end technologies and will be delivered ahead of committed,
                    scheduled time.
                  </p>
                </div>
              </v-col>

              <!-- Spacer -->
              <v-col cols="12" lg="1" class="d-none d-lg-block"></v-col>

              <!-- Middle column -->
              <v-col cols="12" sm="2" lg="2" class="mx-1">
                <div class="pa-4">
                  <h2 class="linespht white--text fade-section">Sactin</h2>
                  <p class="mt-4 white--text fade-section">About Us</p>
                  <p class="mt-2 white--text fade-section">Services</p>
                  <p class="mt-2 white--text fade-section">Community</p>
                  <p class="mt-2 white--text fade-section">Testimonial</p>
                </div>
              </v-col>

              <!-- Right column -->
              <v-col cols="12" sm="6" lg="5" class="mx-1">
                <div class="pa-4">
                  <h2 class="linespht white--text fade-section">Contact Us</h2>
                  <p class="mt-4 white--text fade-section">
                    Mob : +91 8547797619, +91 7558049619
                  </p>
                  <p class="mt-2 white--text fade-section">Email : info@sactin.com</p>
                  <p class="mt-2 white--text fade-section">Street Address</p>
                  <p class="mt-2 white--text fade-section">
                    Sactin Electronics , Kuzhippillil Complex , Piravom Road Vettimoodu
                    P.O,Pampakuda, Kerala 686667
                  </p>
                  <p class="mt-2 white--text fade-section">Website : www.sactin.com</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <!-- Copyright -->
        <v-card flat class="mt-6 transparent">
          <v-card-text class="text-center mx-auto">
            <p class="body-1 white--text mb-0 fade-section">
              Copyright © 2025 Sactin Electronics. All Rights Reserved. Design: Sactin
            </p>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "FooterSection",
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible"); // play animation
          } else {
            entry.target.classList.remove("visible"); // reset animation
          }
        });
      },
      { threshold: 0.2 } // adjust sensitivity
    );

    // observe all animated rows
    document.querySelectorAll(".fade-section").forEach((el) => {
      observer.observe(el);
    });
  },
};
</script>
<style scoped>
.footer-bg {
  background: url("@/assets/footer.jpg") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: auto;
  padding: 40px 0; /* spacing around content */
  color: white !important;
}
/* text animation start */
.fade-section {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s ease-out;
}

.fade-section.visible {
  opacity: 1;
  transform: translateY(0px);
}

/* stop */
</style>
